

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Delete, Pen, Users } from "lucide-react";
import Swal from "sweetalert2";
import { deleteTask, fetchTasksAssigned } from "../../../slices/company/taskSlice";
import moment from "moment";
import TaskUserListModal from "./users_list_modal";
import { customTableStyles } from "../../../utils/tableStylings";

const TaskAssignedUser = () => {
    const [showModalUsers, setShowModalUsers] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const dispatch = useDispatch();

    // Retrieve branches data and loading/error states from the Redux store
    const { tasks = [] } = useSelector(state => state.tasks);
   
    useEffect(() => {
        dispatch(fetchTasksAssigned()); // Fetch tasks when component mounts
    }, [dispatch]);


    const handleDelete = (branchId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Branch.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteTask(branchId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Branch has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
                
            }
        });
       
    };


    const getPriorityClass = (priority) => {
        switch (priority.toLowerCase()) {
            case "low":
                return "bg-primary";
            case "medium":
                return "bg-warning text-dark";
            case "high":
                return "bg-danger";
            default:
                return "bg-secondary";
        }
    };
    
    // Function to return badge class based on status
    const getStatusClass = (status) => {
        switch (status) {
            case "pending":
                return "bg-warning text-dark";
            case "in progress":
                return "bg-primary";
            case "completed":
                return "bg-success";
            default:
                return "bg-secondary";
        }
    };

    // Define table columns
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1, // Display row index (1-based)
            sortable: false,
            width: "50px",
        },
        {
            name: "Task",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
        },
        {
            name: "Estimate Hour",
            selector: (row) => `${row.estimate_hour} Hour`,
            sortable: true,
        },
        {
            name: "Priority",
            cell: (row) => (
                <span className={`badge text-white ${getPriorityClass(row.priority)}`}>
                    {row.priority}
                </span>
            ),
            sortable: true,
        },
        {
            name: "Start Date",
            selector: (row) => moment(row.start_date).format('DD MMMM, YYYY'),
            sortable: true,
        },
        {
            name: "End Date",
            selector: (row) => moment(row.end_date).format('DD MMMM, YYYY'),
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <span className={`badge text-white ${getStatusClass(row.status)}`}>
                    {row.status}
                </span>
            ),
            sortable: true,
        },
        {
            name: "Completed On",
            selector: (row) => row.completed_date?moment(row.completed_date).format('DD MMMM, YYYY'):"Not Completed",
            sortable: true,
        },
        {
            name: "Actions",
            width: "150px",
            cell: (row) => (
                <div>
                    <button
                        className="text-white btn btn-sm bg-primary me-1"
                        onClick={() => handleUserDetail(row)}
                    >
                        <Users/>
                    </button>
                    <Link
                        className="text-white btn btn-sm bg-warning me-1"
                        to={'/task/edit'}
                        state={{initialData: row}}
                    >
                        <Pen/>
                    </Link>
                    <Link
                        className="text-white btn btn-sm bg-danger"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete/>
                    </Link>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    
    const handleUserDetail = (data) => {
        setSelectedData(data);
        setShowModalUsers(true);
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title">Task Assigned</h4>
                            <Link to={'/task/create'} className="btn btn-primary">Create New Task</Link>
                        </div>
                        <div className="card-body">
                    
                            <div className="table-responsive">
                                <DataTable
                                    className="table-hover custom-table"
                                    columns={columns}
                                    data={tasks} // Use filtered data
                                    pagination
                                    striped
                                    customStyles={customTableStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TaskUserListModal show={showModalUsers} onClose={() => setShowModalUsers(false)} heading={'User Detail'} initialData={selectedData} />
            
        </>
    );
}

export default TaskAssignedUser;
